import { Clock, Globe, Mail, Palette, ShieldCheck, Store, UserRound, Users } from 'lucide-react'

export const settingsSections = [
  {
    id: 'organization',
    title: 'Organização e pessoas',
    description: 'Estruture suas unidades, equipes e acessos.',
    items: [
      {
        title: 'Lojas',
        description: 'Cadastre unidades e organize onde sua equipe atua.',
        path: '/stores',
        icon: Store,
        adminOnly: false,
        keywords: 'unidades filiais cadastro',
      },
      {
        title: 'Departamentos',
        description: 'Organize as equipes para direcionar a comunicação.',
        path: '/departments',
        icon: Users,
        adminOnly: false,
        keywords: 'equipes setores cadastro',
      },
      {
        title: 'Usuários',
        description: 'Gerencie pessoas, permissões e vínculos com as equipes.',
        path: '/users',
        icon: UserRound,
        adminOnly: true,
        keywords: 'acessos colaboradores sso cadastro',
      },
      {
        title: 'Fuso horário',
        description: 'Defina o horário usado em datas, prazos, lembretes e relatórios.',
        path: '/tenant-timezone',
        icon: Globe,
        adminOnly: true,
        keywords: 'horario hora data timezone regiao brasilia',
      },
    ],
  },
  {
    id: 'communication',
    title: 'Comunicação e identidade',
    description: 'Personalize a experiência e os canais da sua organização.',
    items: [
      {
        title: 'Horários comerciais',
        description: 'Defina os dias e horários de funcionamento das unidades.',
        path: '/business-hours',
        icon: Clock,
        adminOnly: false,
        keywords: 'janelas expediente funcionamento',
      },
      {
        title: 'Identidade visual',
        description: 'Deixe o sistema com a sua marca: nome, logo e cores.',
        path: '/tenant-branding',
        icon: Palette,
        adminOnly: true,
        keywords: 'aparencia tema marca personalizacao',
      },
      {
        title: 'Configuração de e-mail',
        description: 'Configure o servidor SMTP e o remetente dos e-mails.',
        path: '/tenant-smtp',
        icon: Mail,
        adminOnly: true,
        keywords: 'smtp email servidor envio integracao',
      },
    ],
  },
  {
    id: 'governance',
    title: 'Segurança e governança',
    description: 'Acompanhe as alterações e a responsabilidade por cada ação.',
    items: [
      {
        title: 'Auditoria',
        description: 'Consulte o histórico de ações e alterações no sistema.',
        path: '/audit',
        icon: ShieldCheck,
        adminOnly: true,
        keywords: 'historico rastreabilidade registros seguranca',
      },
    ],
  },
]

export function isSettingsPath(pathname: string) {
  return settingsSections.some((section) =>
    section.items.some((item) => pathname === item.path || pathname.startsWith(`${item.path}/`)),
  )
}
